import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import Button from 'components/buttons/Button';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import Select from 'components/forms/Select';
import isEmpty from 'lodash/isEmpty';
import LoadingIcon from 'mdi-react/LoadingIcon';
import Error from 'components/forms/Error';

import RenderFormInput from 'components/forms/RenderFormInput';
import { requiredValidator, requiredOptionValidator, handleBlur } from 'utils/validators';

const selector = formValueSelector('accountSubscriptionForm');


const SubscriptionForm = (props) => {
  const isSubscriptionTypesLoading = props.subscriptionTypes.loading;
  const isSubscriptionProductsLoading = props.subscriptionProducts.loading;

  return (
    <form className="instance-form" onSubmit={props.handleSubmit}>
      {(isSubscriptionTypesLoading || isSubscriptionProductsLoading) && <div className="loader"><LoadingIcon /></div>}
      <div className="instance-form__body">
        {/* eslint-disable jsx-a11y/label-has-for */}
        <label>Subscription GW id</label>
        <Field
          maxLength="255"
          name="gateway_uid"
          onBlur={handleBlur}
          component={RenderFormInput}
          type="text"
          validate={[requiredValidator]}
        />

        {/* eslint-disable jsx-a11y/label-has-for */}
        <label className="mt-4">Plan type</label>
        <Field
          onBlur={handleBlur}
          name="subscription_type"
          validate={[requiredOptionValidator]}
          component={formProps => (
            <React.Fragment>
              <Select
                value={formProps.input.value}
                onChange={formProps.input.onChange}
                onBlur={() => formProps.input.onBlur(formProps.input.value)}
                options={props.subscriptionTypes.options || []}
              />
              {formProps.meta.touched &&
                ((formProps.meta.error && <Error error={formProps.meta.error} />))}
            </React.Fragment>
          )}
        />

        {/* eslint-disable jsx-a11y/label-has-for */}
        <label className="mt-4">Add on products</label>
        <Field
          onBlur={handleBlur}
          name="products"
          component={formProps => (
            <Select
              isMulti
              value={formProps.input.value}
              onChange={formProps.input.onChange}
              onBlur={() => formProps.input.onBlur(formProps.input.value)}
              options={props.subscriptionProducts.options || []}
            />
          )}
        />
      </div>
      <div className="instance-form__footer">
        {props.toggleModal && (
          <Button type="button" color="secondary" variant="text" onClick={props.toggleModal}>Cancel</Button>
        )}
        <Button
          color="primary"
          variant="contained"
          className="ml-2"
          disabled={props.pristine || props.submitting}
          type="submit"
        >
          {!isEmpty(props.initialValues) ? 'Update' : 'Add' }
        </Button>
      </div>
    </form>
  );
};

SubscriptionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  toggleModal: PropTypes.func,
  subscriptionTypes: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })),
  }).isRequired,
  subscriptionProducts: PropTypes.shape({
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })),
  }).isRequired,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
  initialValues: PropTypes.shape({
    subscriptionId: PropTypes.number,
    gateway_uid: PropTypes.string,
    subscription_type: PropTypes.object,
    products: PropTypes.array,
  }),
  subscriptionTypeFormValue: PropTypes.shape({
    value: PropTypes.number.isRequired,
  }).isRequired,
};

SubscriptionForm.defaultProps = {
  toggleModal: null,
  submitting: false,
  pristine: true,
  initialValues: {},
};


export default compose(
  connect(
    (state, props) => {
      let initialValues = {};
      if (!isEmpty(props.initialValues)) {
        initialValues = {
          ...props.initialValues,
          subscription_type: state.subscriptionTypes.options && props.initialValues.subscription_type
            ? state.subscriptionTypes.options.find(obj => props.initialValues.subscription_type === obj.value)
            : null,
          products: state.subscriptionProducts.options
            ? state.subscriptionProducts.options.filter(obj => props.initialValues.products.includes(obj.value)) : [],
        };
      }
      return {
        subscriptionTypes: state.subscriptionTypes,
        subscriptionProducts: state.subscriptionProducts,
        initialValues,
        subscriptionTypeFormValue: selector(state, 'subscription_type'),
        productsFormValue: selector(state, 'products'),
      };
    },
    {},
  ),
  reduxForm({
    form: 'accountSubscriptionForm',
  }),
)(SubscriptionForm);
